import LogoutIconSvg from '@/assets/svgs/logout.svg';
import { inter500 } from '@/config/fonts';
import DefaultButton from '@/shared/components/Buttons/DefaultButton/DefaultButton';
import classNames from 'classnames';
import { HTMLAttributes } from 'react';

interface LogoutButtonProps extends HTMLAttributes<HTMLButtonElement> {
  onLogout: () => void;
}

const LogoutButton = ({ onLogout, className: _className }: LogoutButtonProps) => {
  return (
    <DefaultButton
      onClick={onLogout}
      bgColor="bg-transparent"
      borderColor="border-0 dark:border dark:border-gray-800"
      textColor="text-gray-default dark:text-gray-500"
      hoverBgColor="hover:bg-base-100"
      hoverTextColor="hover:text-base-content dark:hover:text-white">
      <LogoutIconSvg className="h-5 w-5" />
      <span className={classNames(inter500.className, 'text-sm')}>Log out</span>
    </DefaultButton>
  );
};
export default LogoutButton;
